import {client} from './services/client'

export  const roles = {
    namespaced:true,
    state:{
        roles:undefined,
        collections:[],
    },
    mutations: {
        SET_ROLES (state,roles){
            state.roles = roles
        },
        SET_COLLECTIONS (state,collections){
            state.collections = collections
        },

    },
    actions: {
        getRoles({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/roles/get',
                }).then((response)=>{
                        commit('SET_ROLES',response.data.roles);
                        commit('SET_COLLECTIONS',response.data.collections);
                    }).catch((error)=>{
                        reject(error);
                    })
            })
        },
        setRole({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/roles/save',
                    data:data,
                })
                    .then((response)=>{
                        commit('SET_ROLES',response.data.roles)
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteRole({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/roles/delete/'+id,
                })
                    .then((response)=>{
                        let roles = response.data.roles;
                        commit('SET_ROLES',roles);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getRoles: state  => {
            return state.roles
        },
    }
};
